export const surfaceConstants = {
  TOGGLEDRAWER: "DRAWER_TOGGLE",
  SETTITLE: "PAGE_SETTITLE",
};
